import { PatientModel } from "../api/proxy/practice/practice-models";

export function getPatientFullName(patient: PatientModel | null): string {
    if (!patient) return '';
    let userTitle = "";
    if (patient.firstName) {
        userTitle += patient.firstName;
    }
    if (patient.middleName) {
        userTitle += " " + patient.middleName;
    }
    if (patient.lastName) {
        userTitle += " " + patient.lastName;
    }
    if (patient.suffix) {
        userTitle += " " + patient.suffix;
    }
    return userTitle.trim();
}

export function generateRandomCharacters(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const maxIndex = chars.length - 1;
    let result = '';
    while (result.length < length) {
        const randomIndex = Math.floor(Math.random() * (maxIndex + 1)); // ensures 0 <= index <= maxIndex
        result += chars[randomIndex];
    }
    return result;
}